module.exports = __webpack_public_path__ + "8b0a2be51001f7999eb580ec1e757ba1.svg";